import { AlarmLevel } from '../enums/alarm-level.enum';
import { AlarmType } from '../enums/alarm-type.enum';
import { CreateAlarmRuleCommand } from './create-alarm-rule-command.contract';

export interface CreateTransportAlarmRuleCommand {
  alarmType: AlarmType;
  alarmLevel: AlarmLevel;
  alarmMessage: string;
  zoneId: string;
  customerId: string;
  emailRecipients?: string[];
  userRolesEmailRecipients?: string[];
}

export function toCreateTransportAlarmRuleCommand(command: CreateAlarmRuleCommand): CreateTransportAlarmRuleCommand {
  const { alarmType, alarmLevel, alarmMessage, zoneId, customerId, emailRecipients, userRolesEmailRecipients } =
    command;
  return {
    alarmType,
    alarmLevel,
    alarmMessage,
    zoneId,
    customerId,
    emailRecipients,
    userRolesEmailRecipients,
  };
}
